module.exports = __webpack_public_path__ + "static/media/icon-call-outline.0cef6c15.svg";